export const R_URL_ORIGIN = 'https://r.stripe.com';
export const QA_R_URL_ORIGIN = 'https://qa-r.stripe.com';
export const R_URL = `${R_URL_ORIGIN}/0`;
export const QA_R_URL = `${QA_R_URL_ORIGIN}/0`;
